(function () {

    angular.module('tmx-app')
        .controller('locationEditCtrl', ['$scope', 'resolvedData','LocationTreeService','LocationService','lookupService','$state','ToastService', 
            function LocationEditCtrl($scope,  resolvedData,LocationTreeService,LocationService,lookupService,$state,ToastService) {
        //Functions/Method
                var locationVM=this;
                locationVM.formSubmitted = false;
                locationVM.error_msg = "";
                locationVM.date=new Date().toJSON();
                locationVM.locationCodeStatus=false;
                locationVM.isView=false;
                $scope.dataLoading = false;

                locationVM.readonly={
                    name:false,
                    code:false,
                    type:false,
                    parent:false,
                    disabledParent:false
                };
           
                if(angular.isDefined(resolvedData.location.data)) {
                    locationVM.vm = resolvedData.location.data;
          
                    if(angular.isDefined(resolvedData.location.data.LocationId)) {
                        locationVM.isEdit = true;//locationVM.StartDateInvalid = false;
                        locationVM.disabledNodes=[resolvedData.location.data];
                        locationVM.readonly.name=true;
                        locationVM.readonly.code=true;

                    }
                    else{
            //   locationVM.vm.EffectiveStartDate = tmxUtility.setStartDate(locationVM.date);
            // locationVM.vm.EffectiveEndDate =   new Date(undefined);
                    }
                }
                else{
                    locationVM.vm={};
          // locationVM.vm.EffectiveStartDate = tmxUtility.setStartDate(locationVM.date);
          //   locationVM.vm.EffectiveEndDate =   new Date(undefined);
                }

                if($state.data.info==true) {
                    locationVM.isView=true;
                    locationVM.readonly.name=true;
                    locationVM.readonly.type=true;
                    locationVM.readonly.code=true;                    
                    locationVM.readonly.disabledParent=true;

                }


                locationVM.gridData = resolvedData.locations;

                if(angular.isDefined($state.data.parent)) {
                    locationVM.vm.ParentLocationName=$state.data.parent.name;
                    locationVM.vm.ParentLocationId=$state.data.parent.id;
        //   if($state.data.parent.id!=null)
        //   {locationVM.readonly.parent=true;}
                }
                else {
                    locationVM.vm.ParentLocationName="";
                }
        
        // if(angular.isDefined(locationVM.vm.EffectiveStartDate) && angular.isDefined(locationVM.vm.EffectiveEndDate)){
        //   locationVM.EndDateString=new Date(locationVM.vm.EffectiveEndDate);
        //   locationVM.StartDateString=new Date(locationVM.vm.EffectiveStartDate);
        //   // locationVM.StartDateReadonly=true;
        //   locationVM.minDate=angular.copy(locationVM.vm.EffectiveStartDate);
        // }else{
        //   locationVM.minDate=angular.copy(locationVM.date);
        //   locationVM.StartDateReadonly=false;
        // }

    //     locationVM.getStatus = function() {
    //       if (angular.isDefined(locationVM.vm.EffectiveEndDate) && angular.isDefined(locationVM.vm.EffectiveStartDate)) {
    //             //current date//
    //             var date = locationVM.date.split("T");
    //             date = date[0];

    //             //Start Dat e//
    //             if(angular.isObject(locationVM.vm.EffectiveStartDate)){
    //                 locationVM.vm.EffectiveStartDate = locationVM.vm.EffectiveStartDate.toJSON();
    //             }
    //             if(locationVM.vm.EffectiveStartDate!="Invalid Date" && locationVM.vm.EffectiveStartDate!=null){
    //                 var startDate = locationVM.vm.EffectiveStartDate.split("T");
    //                 startDate = startDate[0];
    //             }

    //             //End Date//
    //             if(angular.isObject(locationVM.vm.EffectiveEndDate)){
    //                 locationVM.vm.EffectiveEndDate = locationVM.vm.EffectiveEndDate.toJSON();
    //             }
    //             if(locationVM.vm.EffectiveEndDate!="Invalid Date" && locationVM.vm.EffectiveEndDate!=null){
    //                 var endDate = locationVM.vm.EffectiveEndDate.split("T");
    //                 endDate = endDate[0];
    //             }
    //             if (endDate >= date && startDate <= date) {
    //                 return "Active";
    //             }
    //             else if(startDate > date){
    //                 return "Pending";
    //             }
    //             else{
    //                 return "Inactive";
    //             }
    //         }
    //         return 'Inactive';
    //     }
    // locationVM.currentStatus = locationVM.getStatus();

    
        // locationVM.onEndDateSelected =function(day)
        // {
        //     var d = new Date(day);
            
        //     if(day!=null)
        //     {
        //       locationVM.vm.EffectiveEndDate = d.toJSON();
        //       locationVM.EndDateInvalid = false;
        //     }
        //     else
        //       locationVM.EndDateInvalid = true;

        //     var st = locationVM.getStatus();
        //     locationVM.currentStatus = st;
        // };

        // locationVM.onStartDateSelected =function(day)
        // {
        //     var d = new Date(day);
            
        //     if(day!=null)
        //     {
        //       locationVM.vm.EffectiveStartDate = d.toJSON();
        //       locationVM.StartDateInvalid = false;
        //       locationVM.minDate = locationVM.vm.EffectiveStartDate;
        //     }
        //     else
        //       locationVM.StartDateInvalid = true;

        //     var st = locationVM.getStatus();
        //     locationVM.currentStatus = st;
        // };

                locationVM.lookup = lookupService;
                locationVM.LocationTreeService = LocationTreeService;
                locationVM.mainGridOptions = $state.data.mainGridOptions;
                lookupService.getLocationTypes().then(function (types){
                    locationVM.locationTypeLookup = types;  
                });


                locationVM.checkLocationCode=function(locationCode){
                    LocationService.checkLocationCode(locationCode).then(function(data){
                        if(data.status.message==locationCode+" "+"location already exist." && locationVM.isEdit!=true){
                            locationVM.locationCodeStatus=true;

                        }
                        else{
                            locationVM.locationCodeStatus=false;
                        }

                    });
                }


                locationVM.getFormErrors = function() {
                    if(angular.isDefined(locationVM.dialogForm)) {
                        if(locationVM.dialogForm.$invalid) {
                            return locationVM.dialogForm.$error;
                        }
                    }
                    return undefined;
                }

                locationVM.errorChanged = function(newErrors,oldErrors) {
                    var errorFormLength = 0;
                    locationVM.error_msg = '' ;
                    if(newErrors!=oldErrors) {
                        locationVM.dirtyFormControls = [];
                        angular.forEach(locationVM.dialogForm, function(value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)) {
                                errorFormLength++;
                                locationVM.dirtyFormControls.push(value.$name);
                            }
                        });

                        if(errorFormLength) {
                            locationVM.error_msg = "Required field(s): " ;
                            for (var i = 0; i < errorFormLength ; i++) {
                                if(i==errorFormLength-1) {
                                    locationVM.error_msg +=  locationVM.dirtyFormControls[i];
                                }
                                else {
                                    locationVM.error_msg +=  locationVM.dirtyFormControls[i] + ", ";
                                }
                            }
                        }
                        else {
                            locationVM.formInvalid = false;
                        }
                    }
                }
                $scope.$watch(locationVM.getFormErrors,locationVM.errorChanged,true);

                locationVM.save = function(action){
                    locationVM.formSubmitted = true;
                    if (locationVM.dialogForm.$invalid) {
                        locationVM.formInvalid = true;
                        locationVM.dirtyFormControls = [];
                        angular.forEach(locationVM.dialogForm, function(value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)) {
                                value.$setTouched();
                                locationVM.dirtyFormControls.push(value.$name);
                            }
                        });
                        locationVM.error_msg = "Required field(s): "
                        for (var i = 0; i < locationVM.dirtyFormControls.length; i++) {
                            if(i==locationVM.dirtyFormControls.length-1) {
                                locationVM.error_msg +=  locationVM.dirtyFormControls[i];
                            }
                            else {
                                locationVM.error_msg +=  locationVM.dirtyFormControls[i] + ", ";
                            }
                        }
                    }
                    else{
                        $scope.dataLoading=true;
                        locationVM.vm.EffectiveStartDate = new Date("2016-01-01").toJSON();
                        locationVM.vm.EffectiveEndDate = new Date("2099-01-01").toJSON()

                        locationVM.vm.$saveOrUpdate().then(function(promise){
                            $scope.dataLoading=false;
                            if(angular.isDefined($state.data.grid.locationTree))
                                $state.data.grid.locationTree.dataSource.read();

                            if(angular.isDefined(promise)) {
                                if(promise.status>=400) {
                                    locationVM.formSubmitted = false;
                                    var displayMsg = "";
                                    if(angular.isDefined(promise.data.ModelState)) {
                                        var models=Object.keys(promise.data.ModelState);
                                        models.forEach(function (key){displayMsg+=(promise.data.ModelState[key])})
                                    }
                                    else{
                                        displayMsg = promise.data.Message;
                                        ToastService.showCustomToastomToast("error", displayMsg);    
                                    }
                                        
                                }
                                else {
                                    if(action=="save") {
                                        $state.searchClear = true;
                                        $state.go("^");
                                    }
                                    else if(action=="saveandnew") {
                                        $state.searchClear = true;
                                        $state.reload($state.current);
                                    }
                                }
                            }
                            else
                                ToastService.showCustomToast("error","Some Error Occured");
                        });
                    }
            // locationVM.vm.$saveOrUpdate().then(function(promise){
            //   if(angular.isDefined($state.data.grid.locationTree))
            //   $state.data.grid.locationTree.dataSource.read();
            //   $state.go("^");
            // });
                };

        // locationVM.saveAndNew = function(){
        //     locationVM.vm.$saveOrUpdate().then(function(promise){
        //       locationVM.vm.ParentLocationName="";
        //       if($state.current.name.indexOf('add')>0){
        //         locationVM.vm= new LocationService();
        //       }else{
        //         var stateName=$state.current.name.replace("edit","add");
        //         $state.go(stateName);
        //       }
        //     });
        // };

                locationVM.cancel = function(){
                    $state.searchClear = true;
                    $state.data.info=false;
                    $state.go("^");
                };
            }]);
})();

